// ----------------------------------------------------------------------

export const GOOGLE_MAP_API = process.env.NEXT_PUBLIC_MAP_API;

export const APP_HOST_API_KEY = process.env.REACT_APP_HOST_API_KEY;

export const EMAIL_JS_SERVICE_ID = process.env.EMAIL_JS_SERVICE_ID;

export const EMAIL_JS_TEMPLATE_ID = process.env.EMAIL_JS_TEMPLATE_ID;

export const EMAIL_JS_PUBLIC_KEY = process.env.EMAIL_JS_PUBLIC_KEY;

export const PAGINATION_PAGE_SIZE = process.env.PAGINATION_PAGE_SIZE;

export const HOST_API_TOKEN = process.env.REACT_APP_HOST_API_TOKEN;
